# GraphQL fragment to get basic info about a sales automation email

fragment EmailAutomation on EmailAutomation {
    id
    emailList {
        id
        ... on MailChimpList {
            name
        }
        ... on ConstantContactList {
            name
        }
        ... on EmailSequenceTemplate {
            name
            creatorUser {
                id
                name
            }
            createdTime
            emailSequenceTemplateMessages {
                id
            }
            htmlUrlPath
            hasCustomPlaceholders
        }
    }
    entersStage {
        id
        name
        position
    }
    exitsStage {
        id
        name
    }
    sendFromUser {
        id
        name
    }
    delay {
        unit
        timespan
    }
    createdTime
    numberOfStagesSpanned
    sendUntilClose
}
